import { render, staticRenderFns } from "./tzgz.vue?vue&type=template&id=49c88f7a&scoped=true&"
import script from "./tzgz.vue?vue&type=script&lang=js&"
export * from "./tzgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c88f7a",
  null
  
)

export default component.exports